import React from 'react';

import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import routes from 'app/routes';
import List from './Pages/List/Index';
import NewCategory from './Pages/New/Index';
import EditCategory from './Pages/Edit/Index';

export default function Index() {
  const router = createBrowserRouter([
    {
      path: routes.admin.resource_categories.index,
      element: <List />,
      children: [
        {
          path: routes.admin.resource_categories.new,
          element: <NewCategory />,
        },
        {
          path: routes.admin.resource_categories.edit(),
          element: <EditCategory />,
        },
      ],
    },

  ]);

  return (
    <RouterProvider router={router} />
  );
}
